export default "__VITE_ASSET__CsXM3QYi__"